import { Datagrid, DateField, List, SelectField, TextField } from 'react-admin';
import React from 'react';
import { planNameChoices } from './constants';

export const ContractList = (props) => {
  return (
    <List {...props} bulkActionButtons={false}>
      <Datagrid rowClick="show">
        {/*<TextField source="contractNumber" label="Номер договора" />*/}
        <SelectField
          source="planName"
          label="Тариф"
          choices={planNameChoices}
        />
        <DateField source="dateFrom" label="Действует с" />
        <DateField source="dateTo" label="Действует по" />
        <TextField source="amount" label="Общая стоимость" />
        <DateField source="dateEnd" label="Действует до" />
      </Datagrid>
    </List>
  );
};
